import { useAuthContext } from '../hooks/useAuthContext';
import { useCompanyContext } from "../hooks/useCompanyContext";
import "./Dossierteelt.css"; 

// Components
import FileList from '../components/FileList';

const Dossiertransport = () => {
  const { user } = useAuthContext(); // ✅ Haal de ingelogde gebruiker op
  const { t } = useCompanyContext();

  return (
    <div className="dossierteelt">
      <h3 className="pageheading">{t.dossierTransport}</h3>

      {/* Iedereen mag bestanden bekijken */}
      <div className="file-list">
        <FileList user={user} />
      </div>
    </div>
  );
};

export default Dossiertransport;
